"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _underscore = require("../../utils/underscore");

var _UIIcon = _interopRequireDefault(require("../../icon/UIIcon"));

var _OptionTypes = require("../../types/OptionTypes");

var UITypeaheadResultsGroup = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(UITypeaheadResultsGroup, _React$Component);

  function UITypeaheadResultsGroup() {
    (0, _classCallCheck2.default)(this, UITypeaheadResultsGroup);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UITypeaheadResultsGroup).apply(this, arguments));
  }

  (0, _createClass2.default)(UITypeaheadResultsGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          group = _this$props.group;
      this._id = this._id || (0, _underscore.uniqueId)('typeahead-results-group-');
      var computedClassName = (0, _classnames.default)("small-caps truncate-text private-typeahead-results-group__label", group.dropdownClassName);
      var computedLabel = group.text || String(group.value);
      return _react.default.createElement("li", {
        className: "private-typeahead-results-group",
        role: "presentation"
      }, _react.default.createElement("div", {
        "aria-hidden": true,
        className: computedClassName,
        id: this._id,
        title: group.title || computedLabel
      }, group.icon ? _react.default.createElement(_UIIcon.default, {
        name: group.icon
      }) : null, " ", computedLabel), _react.default.createElement("ul", {
        "aria-labelledby": this._id,
        className: "private-typeahead-results-group__list list-unstyled",
        role: "listbox"
      }, children));
    }
  }]);
  return UITypeaheadResultsGroup;
}(_react.default.Component);

exports.default = UITypeaheadResultsGroup;
UITypeaheadResultsGroup.propTypes = {
  children: _propTypes.default.node,
  group: _OptionTypes.OptionGroupType.isRequired
};
UITypeaheadResultsGroup.displayName = 'UITypeaheadResultsGroup';
module.exports = exports.default;